export const normalizeRole = (role) => {
  if (!role || role === 'user') return 'partybuddy';
  return role;
};

export const roleLabelMap = {
  partybuddy: { de: 'PartyBuddy', en: 'PartyBuddy' },
  organizer: { de: 'Veranstalter/Lokal', en: 'Organizer/Venue' },
  artist: { de: 'Künstler/DJ', en: 'Artist/DJ' },
};

export const getRoleLabel = (role, lang = 'de') => {
  const normalized = normalizeRole(role);
  return roleLabelMap[normalized]?.[lang] || roleLabelMap.partybuddy[lang];
};

export const canViewQrCode = (viewerUser, profileUser) => {
  if (!viewerUser || !profileUser) return false;

  const profileRole = normalizeRole(profileUser.role || profileUser.profile?.role || profileUser.role);

  if (viewerUser.uid === profileUser.id || viewerUser.uid === profileUser.uid) return true;
  return profileRole === 'artist' || profileRole === 'organizer';
};
